
webpack.register(
    'modules/home-selection-tabs/home-selection-tabs',
    function() {
        return import('modules/home-selection-tabs/home-selection-tabs');
    },
    true
);